export const REQUEST_INIT_MAGNET_BLACKLIST = 'REQUEST_INIT_MAGNET_BLACKLIST';
export const SUCCEED_INIT_MAGNET_BLACKLIST = 'SUCCEED_INIT_MAGNET_BLACKLIST';
export const REQUEST_SEARCH_MAGNET_BLACKLIST = 'REQUEST_SEARCH_MAGNET_BLACKLIST';
export const SUCCEED_SEARCH_MAGNET_BLACKLIST = 'SUCCEED_SEARCH_MAGNET_BLACKLIST';
export const REQUEST_REFRESH_MAGNET_BLACKLIST = 'REQUEST_REFRESH_MAGNET_BLACKLIST';
export const SUCCEED_REFRESH_MAGNET_BLACKLIST = 'SUCCEED_REFRESH_MAGNET_BLACKLIST';
export const SET_MAGNET_BLACKLIST_SEARCH = 'SET_MAGNET_BLACKLIST_SEARCH';

export const REQUEST_DELETE_MAGNET_BLACKLIST = 'REQUEST_DELETE_MAGNET_BLACKLIST';
export const SUCCEED_DELETE_MAGNET_BLACKLIST = 'SUCCEED_DELETE_MAGNET_BLACKLIST';
export const REQUEST_ADD_MAGNET_BLACKLIST = 'REQUEST_ADD_MAGNET_BLACKLIST';
export const SUCCEED_ADD_MAGNET_BLACKLIST = 'SUCCEED_ADD_MAGNET_BLACKLIST';